import { createContext } from 'react';
import { QUERY_KEYS_SAS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';
import { useAnnualSynthesis } from '../../../Common/hooks/useAnnualSynthesis';

export const IDCRASChartsDataContext = createContext();

const normalizeSize = (value) => {
    if (!value) {
        return 'Não informado';
    }

    const sizeMap = {
        '1': 'Pequeno I',
        '2': 'Pequeno II',
        '3': 'Médio',
        '4': 'Grande',
    };

    return sizeMap[value] || value;
};

const IDCRASChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();
    
    const requestFilters = {
        year: filters?.year?.value ?? '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };
    
    const generalQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCRAS_GENERAL,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcras/general',
        },
        requestFilters
    );

    const sizeQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCRAS_SIZE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcras/size',
        },
        requestFilters
    );

    const structureQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCRAS_STRUCTURE,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcras/structure',
        },
        requestFilters
    );

    const humanResourcesQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCRAS_HUMAN_RESOURCES,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcras/humanResources',
        },
        requestFilters
    );

    const servicesQuery = useChartsData(
        {
            key: QUERY_KEYS_SAS.IDCRAS_SERVICES,
            url: 'governanceroom/socialdashboard/socialAssistanceSurveillance/idcras/services',
        },
        requestFilters
    );

    // O backend repete o mesmo ano (uma linha por unidade); sintetiza em um ponto por ano.
    const general = useAnnualSynthesis(generalQuery.data?.anualEvolution, [
        'idcras'
    ]);
    const structure = useAnnualSynthesis(structureQuery.data?.anualEvolution, [
        'estrutura_fisica'
    ]);
    const humanResources = useAnnualSynthesis(
        humanResourcesQuery.data?.anualEvolution,
        ['recursos_humanos']
    );
    const services = useAnnualSynthesis(servicesQuery.data?.anualEvolution, [
        'servicos'
    ]);

    const chartData = {
        general,

        size:
            sizeQuery.data?.anualEvolution?.map((item) => ({
                ...item,
                porte: normalizeSize(item.porte),
            })) ?? [],

        structure,

        humanResources,

        services,
    };

    const isLoading =
        generalQuery.isLoading ||
        sizeQuery.isLoading ||
        structureQuery.isLoading ||
        humanResourcesQuery.isLoading ||
        servicesQuery.isLoading;

    const isError =
        generalQuery.isError ||
        sizeQuery.isError ||
        structureQuery.isError ||
        humanResourcesQuery.isError ||
        servicesQuery.isError;

    return (
        <IDCRASChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                //filters,
                rawData: {
                    general: generalQuery.data,
                    size: sizeQuery.data,
                    structure: structureQuery.data,
                    humanResources: humanResourcesQuery.data,
                    services: servicesQuery.data,
                },
            }}
        >
            {children}
        </IDCRASChartsDataContext.Provider>
    );
};

export default IDCRASChartsDataProvider;